var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.75977C4.1 1.75977 1 4.85977 1 8.75977C1 12.6598 4.1 15.7598 8 15.7598C11.9 15.7598 15 12.6598 15 8.75977C15 4.85977 11.9 1.75977 8 1.75977ZM8 14.7598C4.7 14.7598 2 12.0598 2 8.75977C2 5.45977 4.7 2.75977 8 2.75977C11.3 2.75977 14 5.45977 14 8.75977C14 12.0598 11.3 14.7598 8 14.7598Z",
    fill: "#E12121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 12.2598L8 9.55977L5.3 12.2598L4.5 11.4598L7.2 8.75977L4.5 6.05977L5.3 5.25977L8 7.95977L10.7 5.25977L11.5 6.05977L8.8 8.75977L11.5 11.4598L10.7 12.2598Z",
    fill: "#E12121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.56ec83a1986bb8c311899f7dde654e61.svg";
export { ForwardRef as ReactComponent };